//@ts-ignore
import React, {useState} from 'react'
import {styled} from 'styled-components'
import { getLocalizedText } from '../../../../utils/localize'

import {Table, TableFilter} from '../../../myTable/MyTable'
import {useAppSelector} from '../../../../hooks/redux'

import {
    Empty,
    IndicatorsSignalBody,
    IndicatorsSignalHead,
    NothingFound,
} from './tableComponents'
import {MAX_PER_PAGE} from '../../../../constants/other'
import {getSubjectId, isFullByAge} from "../../../../pages/biomarkers/[id]/IndicatorsAndSignals";
import {TableStyle} from "../interpretation/InterpretationTable";

function getSignalsByIndicator(indicator: any, signals: any) {
    return (indicator.signals || [1000, 1001])
        .map((it: any) => {
            return signals[it]
        })
        .filter((it: any) => it)
}

export const THead = styled.thead`
  height: 20px;
  background: var(--surface-main, #f7f7f7);

  td {
    padding: 8px;
  }
`

const IndicatorsSignalTable = (props: any) => {
    const { language = 'en' } = props
    let [filter, setFilter] = useState({
        sort: '_id',
        perPage: MAX_PER_PAGE,
        search: '',
        direction: '_id',
        special: {
            age: '',
            key: ''
        },
    })
    const {indicators} = useAppSelector((state) => state.data)
    let items = Object.values(indicators).map(it => {
        return {...it, isWarn: !isFullByAge(it, filter.special.age, filter.special.key)}
    });


    return (
        <>
            <TableFilter filter={filter}
                         onChangeCustomFilter={(it: any) => {
                             console.log("qqqqq on change custom filter", it);
                             setFilter({...filter, special: it})
                         }}
                         setFilter={setFilter}
                         name={'Create New Biomarker'}
                         url={'/' + getSubjectId() + '/biomarkers/create-biomarker'}
            ></TableFilter>
            <Table
                Head={IndicatorsSignalHead}
                Body={IndicatorsSignalBody}
                EmptyItems={Empty}
                NothingFound={NothingFound}
                onConnect={props.onConnect}
                connectIds={props.connectIds}
                apiSearchFileds={['name']}
                onFilter={(it: any, filter: any) => {
                    if (filter._id) {
                        return it._id == filter._id
                    }
                    return true
                }}
                onSearch={(it: any, reg: any) => {
                    return reg.test(getLocalizedText(it.name, language))
                }}
                onChangeFilter={(v: any) => {
                    setFilter(v)
                }}
                filter={filter}
                items={items}
            />
        </>
    )
}

export default IndicatorsSignalTable